import { render } from "./UserPulseLogItem.vue?vue&type=template&id=0b48d496&scoped=true"
import script from "./UserPulseLogItem.vue?vue&type=script&lang=js"
export * from "./UserPulseLogItem.vue?vue&type=script&lang=js"

import "./UserPulseLogItem.vue?vue&type=style&index=0&id=0b48d496&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b48d496"]])

export default __exports__